import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import Logo from './Logo';
import NavbarToggleButton from './NavbarToggleButton';
import Navigation from './Navigation';

interface Props {
  className?: string;
}

const Root = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  color: theme.palette.text.primary,
  '& ::-webkit-scrollbar-thumb': {
    boxShadow: 'inset 0 0 0 20px rgba(0, 0, 0, 0.24)',
  },
  '& ::-webkit-scrollbar-thumb:active': {
    boxShadow: 'inset 0 0 0 20px rgba(0, 0, 0, 0.37)',
  },
}));

const NavbarStyleContent = (props: Props) => {
  return (
    <Root
      className={clsx(
        'flex flex-auto flex-col overflow-hidden h-full',
        props.className
      )}
    >
      <div className="flex flex-row items-center shrink-0 h-48 md:h-76 px-12 NavbarStyle-header">
        <div className="flex flex-1 logo-container">
          <Logo />
        </div>

        <NavbarToggleButton className="w-40 h-40 p-0 toggle-button" />
      </div>

      <div className="flex flex-1 flex-col min-h-0 overflow-auto">
        <Navigation />
      </div>
    </Root>
  );
};

export default NavbarStyleContent;
